import PersonIcon from "../../../../assets/svg/Person.svg?react";

export function Person() {
  return <PersonIcon />;
}
